/**
 * A position as people say it: 1st, 2nd, 3rd, 4th. Used where a number alone would not read as a
 * place in a running order - "Queued · 3rd" on the song preview.
 */
export const ordinal = (position: number): string => {
  // 11th, 12th and 13th break the pattern the last digit otherwise sets, so they are matched first.
  const teens = position % 100;
  if (teens >= 11 && teens <= 13) return `${position}th`;

  switch (position % 10) {
    case 1:
      return `${position}st`;
    case 2:
      return `${position}nd`;
    case 3:
      return `${position}rd`;
    default:
      return `${position}th`;
  }
};
